module.exports = __webpack_public_path__ + "static/media/webIcons-04.07102995.svg";